(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Header shrink on scroll ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var lastState = false;
    var onScroll = function () {
      var shouldShrink = window.scrollY > 40;
      if (shouldShrink !== lastState) {
        header.classList.toggle('is-shrunk', shouldShrink);
        lastState = shouldShrink;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile nav toggle (hamburger -> X, slide-down panel) ---- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobilePanel = document.querySelector('[data-mobile-panel]');
  if (navToggle && mobilePanel) {
    navToggle.addEventListener('click', function () {
      var isOpen = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!isOpen));
      mobilePanel.classList.toggle('is-open', !isOpen);
    });
  }

  /* ---- Reveal-on-scroll + section-specific triggers (gauge, ring, steps) ---- */
  var revealEls = document.querySelectorAll('.reveal, [data-gauge-wrap], .steps, .trust-security__visual, .ring-card');

  if ('IntersectionObserver' in window && !reduceMotion) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Gauge: set needle rotation + count-up readout when visible ---- */
  var gaugeWrap = document.querySelector('[data-gauge-wrap]');
  var gaugeSvg = document.querySelector('[data-gauge]');
  var gaugeValueEl = document.querySelector('[data-gauge-value]');

  function animateGauge() {
    if (!gaugeSvg) return;
    var target = parseFloat(gaugeSvg.getAttribute('data-target')) || 0;
    var needle = gaugeSvg.querySelector('[data-needle]');
    var arc = gaugeSvg.querySelector('.gauge__arc');

    // Needle sweeps from -90deg (0%) to +90deg (100%) with spring overshoot via CSS transition.
    var angle = -90 + (target / 100) * 180;
    if (needle) {
      needle.style.transform = 'rotate(' + angle + 'deg)';
      needle.setAttribute('transform', ''); // clear the static inline attribute so the CSS transform takes over
    }

    // Arc length is ~283 (semi-circle r=90). Offset shrinks as target grows.
    if (arc) {
      var offset = 283 - (283 * (target / 100));
      arc.style.setProperty('--gauge-offset', offset);
      arc.style.strokeDashoffset = offset;
    }

    // Count-up readout, snappy not linear-lethargic.
    if (gaugeValueEl) {
      var start = 0;
      var duration = reduceMotion ? 0 : 900;
      var startTime = null;
      function step(ts) {
        if (startTime === null) startTime = ts;
        var progress = duration === 0 ? 1 : Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic, snappy finish
        var current = Math.round(start + (target - start) * eased);
        gaugeValueEl.textContent = current;
        if (progress < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }
  }

  if (gaugeWrap && 'IntersectionObserver' in window) {
    var gaugeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateGauge();
            gaugeObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    gaugeObserver.observe(gaugeWrap);
  } else if (gaugeWrap) {
    animateGauge();
  }

  /* ---- Steps progress line fill ---- */
  var stepsEl = document.querySelector('[data-steps]');
  if (stepsEl && 'IntersectionObserver' in window) {
    var stepsObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            stepsObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    stepsObserver.observe(stepsEl);
  }

  /* ---- Trust ring fill ---- */
  document.querySelectorAll('[data-ring]').forEach(function (ring) {
    var wrap = ring.closest('.ring-card') || ring.closest('.trust-security__visual');
    if (!wrap || !('IntersectionObserver' in window)) {
      wrap && wrap.classList.add('is-visible');
      return;
    }
    var ringObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            ringObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    ringObserver.observe(wrap);
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var answer = item.querySelector('.faq-item__answer');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      if (isOpen) {
        answer.setAttribute('hidden', '');
      } else {
        answer.removeAttribute('hidden');
      }
    });
  });
})();
